module.exports = __webpack_public_path__ + "img/2.a41fb6e8.jpg";